import { render, staticRenderFns } from "./ArchivedAccount.vue?vue&type=template&id=c4d8303e&scoped=true"
import script from "./ArchivedAccount.vue?vue&type=script&lang=js"
export * from "./ArchivedAccount.vue?vue&type=script&lang=js"
import style0 from "./ArchivedAccount.vue?vue&type=style&index=0&id=c4d8303e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d8303e",
  null
  
)

export default component.exports